import { useTheme, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import ExoAvatar from '../exo/ExoAvatar';
import DateTimeLabel from '../label/DateTimeLabel';

/**
 * Compact history of a request's edits: who changed it and when, newest first.
 * Renders nothing for the common case of a request that was never edited.
 */
const RequestEditHistory = ({ request }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const edits = request.edits || [];
  if (edits.length === 0) return null;

  return (
    <Box
      className="w-full rounded-xl flex flex-col gap-2 px-4 py-2"
      sx={{
        backgroundColor: colors.card,
        border: `1px solid ${colors.selected}`,
      }}
    >
      <Typography variant="h6">
        {`${t('Edit history')} (${edits.length}×)`}
      </Typography>
      {[...edits].reverse().map((edit) => {
        const editor = edit.editedBy;
        const name = editor
          ? `${editor.firstName} ${editor.lastName}`
          : t('Unknown');
        return (
          <Box key={edit.id} className="flex items-center gap-2">
            <ExoAvatar
              picture={editor?.picture ? editor.picture.temporaryUrl : ''}
              name={name}
              size="24px"
            />
            <Typography variant="body2">{name}</Typography>
            <Typography variant="body2" className="ml-auto" sx={{ opacity: 0.7 }}>
              <DateTimeLabel dateTime={edit.createdAt} />
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default RequestEditHistory;
